<template>
  <div id="contenedor-contrato-directorio">
    <v-toolbar v-if="showTitle" dense flat>
      <v-toolbar-title>
        <v-icon left color="primary">mdi-at</v-icon>
        Directorio
      </v-toolbar-title>
      <v-spacer />
      <v-chip
        @click="toggleSelectAddress"
        :color="allSelected ? 'grey lighten-2' : 'transparent'"
      >
        <v-icon left small>
          mdi-{{ allSelected ? 'checkbox-intermediate' : 'checkbox-blank-outline' }}
        </v-icon>
        Seleccionar todos
      </v-chip>
    </v-toolbar>

    <v-divider />

    <v-list dense v-if="!$apollo.queries.contratoDirectorios.loading">
      <v-list-item
        v-for="directorio in contratoDirectorios"
        :key="directorio.id"
        class="d-flex justify-space-between"
      >
        <v-list-item-action>
          <v-checkbox
            v-model="selected"
            :value="directorio.correoElectronico"
            hide-details
          />
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ directorio.nombre }}</v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold">
            {{ directorio.correoElectronico }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import CONTRATO_DIRECTORIOS from '@/graphql/querys/administracion/contratos/contrato/directorios/contratoDirectorios.gql';

export default {
  name: 'ContratoDirectorio',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    idContrato: {
      type: String,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [...this.value],
    };
  },
  apollo: {
    contratoDirectorios: {
      query: CONTRATO_DIRECTORIOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    allSelected() {
      return (
        this.contratoDirectorios
        && this.selected.length === this.contratoDirectorios.length
      );
    },
  },
  watch: {
    selected: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    toggleSelectAddress() {
      this.selected = this.allSelected
        ? []
        : this.contratoDirectorios.map((d) => d.correoElectronico);
    },
  },
};
</script>

<style lang="scss">
</style>
